var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "full-height": "" } },
    [
      _vm.loading ? _c("Loading", { attrs: { text: _vm.text } }) : _vm._e(),
      _vm._v(" "),
      _vm.maintenanceInfo.is_active
        ? _c("div", { staticClass: "maintenance-container" }, [
            _c("div", { staticClass: "maintenance-message" }, [
              _c("h2", [_vm._v("メンテナンス中")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.maintenanceInfo.message))]),
            ]),
          ])
        : [
            _c("Header", { attrs: { htitle: _vm.htitle } }),
            _vm._v(" "),
            _c("div", { staticClass: "category-container" }, [
              _c(
                "div",
                { staticClass: "scrollable-major-buttons" },
                _vm._l(_vm.categoryMajor, function (category, index) {
                  return _c(
                    "el-button",
                    {
                      key: index,
                      class: [
                        "category-button",
                        {
                          active:
                            _vm.selectedMajorCategoryId === category.categoryId,
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.selectMajorCategory(category)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(category.name) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              this.selectedMajorCategoryId
                ? _c(
                    "div",
                    { staticClass: "scrollable-buttons" },
                    _vm._l(_vm.categoryMedium, function (category, index) {
                      return _c(
                        "el-button",
                        {
                          key: index + "_medium",
                          staticClass: "category-btn",
                          class: {
                            active:
                              _vm.selectedMediumCategoryId ==
                              category.categoryId,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectMediumCategory(category)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(category.name) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedMediumCategoryId
                ? _c(
                    "div",
                    { staticClass: "scrollable-buttons" },
                    _vm._l(_vm.categorySmall, function (category, index) {
                      return _c(
                        "el-button",
                        {
                          key: index + "_small",
                          staticClass: "category-btn",
                          class: {
                            active:
                              _vm.selectedSmallCategoryId ==
                              category.categoryId,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectSmallCategory(category)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(category.name) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedSmallCategoryId
                ? _c(
                    "div",
                    { staticClass: "scrollable-buttons" },
                    _vm._l(_vm.categoryTiny, function (category, index) {
                      return _c(
                        "el-button",
                        {
                          key: index + "_small",
                          staticClass: "category-btn",
                          class: {
                            active:
                              _vm.selectedTinyCategoryId == category.categoryId,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectTinyCategory(category)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(category.name) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "main",
              [
                _c(
                  "div",
                  { staticClass: "product__scroll" },
                  _vm._l(_vm.product_list, function (product, index) {
                    return product && product.view
                      ? _c("Product", {
                          key: index,
                          attrs: { product: product },
                          on: { "show-modal": _vm.openModal },
                        })
                      : _vm._e()
                  }),
                  1
                ),
                _vm._v(" "),
                !_vm.isScanView && _vm.canShowMore
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "12px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "100%",
                              "text-align": "center",
                              "border-radius": "8px",
                              border: "1px solid var(--grayColor)",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.loadMore()
                              },
                            },
                          },
                          [_vm._v("もっと見る")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isScanView
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "12px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "100%",
                              "text-align": "center",
                              "border-radius": "8px",
                              border: "1px solid var(--grayColor)",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.reloadHomeFirstPage()
                              },
                            },
                          },
                          [_vm._v("商品一覧を再読み込み")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("el-button", {
                  staticClass: "btn-scroll-top",
                  attrs: { icon: "el-icon-top" },
                  on: { click: _vm.scrollTop },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.modalData
              ? _c("div", { staticClass: "modal" }, [
                  _c("div", { staticClass: "modal__box" }, [
                    _c("img", {
                      staticClass: "modal__box__back",
                      attrs: { src: "/resource/icon_cross_in_circle.svg" },
                      on: { click: _vm.closeModal },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "modal__box__image",
                      attrs: { src: _vm.modalData.image },
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "modal__box__product-name" }, [
                      _vm._v(_vm._s(_vm.modalData.product_name)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "modal__box__product-price" }, [
                      _vm._v(
                        _vm._s(
                          _vm.modalData.price
                            ? `${_vm.numberFormat(_vm.modalData.price)}円${
                                _vm.modalData.unit_code
                                  ? ` / ${_vm.modalData.unit_code}`
                                  : ""
                              }`
                            : ""
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("Footer"),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }